class SiteNavigation {
  constructor(element) {
    if (!(element instanceof HTMLElement)) {
      throw new TypeError('Invalid element');
    }

    this.element = element;
    this.breakpoint = 992;
    this.bottomNav = this.element.querySelector('#bottom-nav');
    this.minScrollRequired = 300; // the minimum amount before hide logic comes into effect.
    this.prevScrollY = window.scrollY;
    this.currScrollProgressY = 0;
    this.scrollRequired = 100;

    this.initEvents();
  }

  initEvents() {
    (this.element.querySelectorAll('.menu-toggle,.nav-toggle') ?? []).forEach(
      (el) => el.addEventListener('click', this.toggle.bind(this)),
    );

    (this.element.querySelectorAll('.submenu-toggle') ?? []).forEach((el) => {
      if (el.nextElementSibling && el.nextElementSibling.classList.contains('submenu')) {
        el.addEventListener('click', this.toggleSubmenu.bind({ ...this, ...{ menu: el.nextElementSibling } }));
      }
    });

    (this.element.querySelectorAll('.has-submenu') ?? []).forEach(
      (el) => el.addEventListener('mouseenter', this.mouseEnter.bind(this)),
    );
    (this.element.querySelectorAll('.has-submenu') ?? []).forEach(
      (el) => el.addEventListener('mouseleave', this.mouseLeave.bind(this)),
    );

    window.addEventListener('scroll', this.toggleScrollStatus.bind(this), { passive: true });
  }

  toggleScrollStatus() {
    if (this.element) {
      const scrollDirection = window.scrollY > this.prevScrollY ? 'down' : 'up';
      if (scrollDirection === 'down') {
        const scrollAmount = window.scrollY - this.prevScrollY;
        this.currScrollProgressY += scrollAmount;
      } else {
        this.currScrollProgressY = 0;
      }

      if (
        window.scrollY > this.minScrollRequired
        && window.innerWidth < this.breakpoint
        && scrollDirection === 'down'
        && this.currScrollProgressY > this.scrollRequired
      ) {
        this.element.classList.add('hidden');
      } else {
        this.element.classList.remove('hidden');

        // reset the progress as we are now going the up (maybe).
        // this.currScrollProgressY = 0;
      }

      // if (document.body.classList.contains('has-ticker')) {
      //   if (window.scrollY < 61) {
      //     this.element.style.top = `${70 - window.scrollY}px`;
      //   } else {
      //     this.element.style.top = 'translateY(-60px)';
      //   }
      // }

      this.prevScrollY = window.scrollY;
    }
  }

  mouseEnter() {
    this.bottomNav.classList.add('show-overlay');
  }

  mouseLeave() {
    this.bottomNav.classList.remove('show-overlay');
  }

  toggle(ev) {
    ev.preventDefault();
    this.element.classList.toggle('menu-open');
    document.documentElement.classList.toggle('main-nav-open');

    const use = ev.currentTarget.querySelector('svg use');
    if (use) {
      use.setAttribute('xlink:href', this.element.classList.contains('menu-open') ? '#icon--close-nav' : '#icon--menu');
    }
  }

  toggleSubmenu(ev) {
    ev.preventDefault();

    (this.element.querySelectorAll('.submenu-toggle.open') ?? []).forEach((el) => {
      if (ev.currentTarget !== el) {
        el.classList.remove('open');
        if (el.parentElement) {
          el.parentElement.classList.remove('open');
        }
      }
    });

    ev.currentTarget.classList.toggle('open');
    if (ev.currentTarget.parentElement) {
      ev.currentTarget.parentElement.classList.toggle('open');
    }
  }
}

export default SiteNavigation;
